module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-3-green.svg";